import React from 'react'
import { i18nTranslate } from 'src/utils'
import { AddressBook, MetaDecorator } from 'src/views/components'
import { customerContainer } from 'src/models'
import { pageNames } from 'src/routes/pathParams'
import { trackGTMEvents } from 'src/utils'

class MyAccountShipping extends React.Component {
  componentDidMount() {
    this.setProfileShippingGTMDetails()
  }

  getDataModal() {
    return {
      myAccountShippingAddressTitle: i18nTranslate(
        'myAccountShippingAddressPage.title',
        'Shipping Address Book | Nu Skin'
      ),
      description: 'Shipping Address Book Page',
    }
  }

  setProfileShippingGTMDetails = () => {
    const userDetails = customerContainer.profileResponse || {}
    const { myaccountshipping } = pageNames

    /**
     * @info
     * GTM Datalayer -  Send event when user initially loads/visits My Account Shipping Address Book page.
     */

    trackGTMEvents({
      event: 'nuskin-profile',
      eventType: 'shipping',
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'NuskinProfileShipping',
      //     pagePath: myaccountshipping,
      //     pageTitle: 'My Account Shipping Address Book',
      //     userDetails: {
      //       userId: userDetails?.id || '',
      //       email: userDetails?.email || '',
      //       firstName: userDetails?.firstName || '',
      //       lastName: userDetails?.lastName || '',
      //     },
      //     address: userDetails?.address || {},
      //     isDefaultAddress: userDetails?.address?.isDefault || false,
      //     platform: 'equinox',
      //   },
    })
  }

  render() {
    const data = this.getDataModal()
    return (
      <>
        <MetaDecorator
          title={data?.myAccountShippingAddressTitle}
          imageUrl=""
          imageAlt=""
          description={data?.description}
          location={this.props}
        />
        <AddressBook />
      </>
    )
  }
}

export { MyAccountShipping }
// export default MyAccountShipping
export default MyAccountShipping
